import React from 'react';
import {Col, Panel, Row} from 'react-bootstrap';
import moment from 'moment';

import OtherValidation from "../validation/otherValidation";
import { foreignLanguages, statusTypes } from "../config/constants";

const OtherInfoSummary = (props) => {
  const withoutValidation = props.withoutValidation;
  const validationStatus = new OtherValidation().getValidationStatus(props);
  const teasDate = props.teas.date ? moment(props.teas.date).format('MM/DD/YY') : '';
  const renderForeignLanguages = () => {
    const languages = Object.keys(props.foreignLanguage).filter(lang => lang !== 'otherLanguage' && props.foreignLanguage[lang]);
    if(languages.length === 0)
      return (
        <div>No Foreign Languages</div>
      );

    return (
      <ul>
        {languages.map((language) => {
          const text = language === 'other' ? props.foreignLanguage.otherLanguage : foreignLanguages[language];
          return (
            <li key={language}>{text}</li>
          )
        })}
      </ul>
    )
  };
  return(
    <Panel className="other-info-panel" header="Other Information" bsStyle={withoutValidation ? statusTypes.INFO : validationStatus.section.status}>
      <Row>
        <Col md={6}>
          <h3 className="summary-sub-category">TEAS</h3>
          <dl className="dl-horizontal">
            <dt>TEAS Location</dt>
            <dd>{props.teas.location}</dd>
            <dt>TEAS Score</dt>
            <dd>{props.teas.score}</dd>
            <dt>TEAS Date</dt>
            <dd>{teasDate}</dd>
            <dt>TEAS Times Taken</dt>
            <dd>{props.teas.timesTaken}</dd>
          </dl>
        </Col>
        <Col md={6}>
          <h3 className="summary-sub-category">Foreign Languages</h3>
          {renderForeignLanguages()}
        </Col>
      </Row>
    </Panel>
  );
};

export default OtherInfoSummary;